
  <ng-container *appLet="{
    culture: culture$ | async,
  } as $comp">
  @if (month) {
    <div class="date-range-picker-month" [id]="month.id">
      <div class="date-range-picker-month-title">
        {{ month.nameOfMonth | date: DateFormats.FULL_MONTH_FULL_YEAR : undefined : $comp.culture || FALLBACK_CULTURE }}
      </div>
      <div class="date-range-picker-month-week-days">
        @for (dayName of dayNamesOfWeek$ | async; track $index) {
          <div class="date-range-picker-month-week-days__name">{{ dayName }}</div>
        }
      </div>
      <div class="date-range-picker-month-days">
        @for (day of month.days; track $index) { 
          @if (day) {
            <div
              class="date-range-picker-month-days__day"
              [ngClass]="{
                'date-range-picker-month-days__day--active-range': day.isInRange,
                'date-range-picker-month-days__day--active': day.isFirstDayOfRange || day.isLastDayOfRange,
                'date-range-picker-month-days__day--start': day.isFirstDayOfRange,
                'date-range-picker-month-days__day--end': day.isLastDayOfRange,
                'date-range-picker-month-days__day--disabled': day.isDisabled,
              }"
              (click)="onDayClick(day)"
            >
              {{ day.numberOfDay }}
            </div>
          } @else {
            <div class="date-range-picker-month-days__day"></div>
          } 
        }
      </div>
    </div>}
  </ng-container>
